<template>

  <main class="container profile_page" style="min-height:600px">
    <div v-if="loading" class="d-flex flex-row justify-content-center loading_card">
      <div v-if="loading" class="loading_card_spinner">
        <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3" color="var(--primary-color)" />
      </div>
    </div>
    <section v-else class="account">
      <!-- العنوان ورابط الخروج في المنتصف -->
      <div>
        <h2 class="title_profile">{{ $t('Account') }}</h2>
        <a @click="show2 = true" class="logout logout_title">
          <i class=" bi bi-person"></i>
          {{ $t('logOut') }}
        </a>
      </div>

      <!-- الشبكة الرئيسية: جدول الطلبات على اليسار وتفاصيل الحساب على اليمين -->
      <div class="content-grid">
        <!-- جدول سجل الطلبات -->
        <div class="order-history">
          <h3>{{ $t('Order history') }}</h3>
          <i class="fa fa-spinner fa-spin " v-if="loading_order" style="font-size:35px;text-align:center"></i>

          <table v-if="orders.length != 0">
            <thead>
              <tr>
                <th>{{ $t('order') }}</th>
                <th>{{ $t('date') }}</th>
                <th>{{ $t('Payment Status') }}</th>
                <th>{{ $t('state') }}</th>
                <th>{{ $t('total') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in orders" :key="index">
                <td class="order-number" @click="$router.push({
                  name: 'invoice',
                  params: {
                    storeName: $store.storeName
                    , id: item.id,
                    lang: $store.state.routeLang
                  }
                });">#{{ item.invoice_id }}</td>
                <td>{{ item.date }}</td>
                <td><span class="badge pending">{{ item.state }}</span></td>
                <td><span class="badge unfulfilled">{{ item.state }}</span></td>
                <td>{{ item.total_price }} {{ $store.state.UnitPrice }}</td>
              </tr>
            </tbody>
          </table>

          <div v-if="orders.length != 0" class="d-flex flex-row justify-content-center mt-5">
            <nav aria-label="Page navigation example">
              
<b-pagination
  v-if="count > 0"
  v-model="page"
  :total-rows="count"
  :per-page="pageSize"
  :prev-text="$t('prev')"
  :next-text="$t('next')"
  pills
  size="sm"
  @change="handlePageChange"
/>

            </nav>
          </div>
          <p v-if="orders.length == 0">{{ $t("You haven't placed any orders yet.") }}
          </p>
        </div>


        <!-- تفاصيل الحساب على اليمين -->
        <aside class="account-details">
          <h3>{{ $t('Account details') }}</h3>
          <p> {{ form.name }}</p>
          <i class="fa fa-spinner fa-spin " v-if="loading_address" style="font-size:35px;text-align:center"></i>

           <div  v-if="address.length != 0">
          <p v-for="(item, index) in address" :key="index">
            {{ item.title }} ,{{ item.description }}
            <!-- <a href="#">{{ $t('View address') }}</a> -->


          </p>
           </div>
          <p v-else>{{ $t("You haven't placed any address yet.") }}</p>
        </aside>
      </div>
    </section>

    <Transition>
      <div v-if="show2" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">{{ $t("confirmlogout") }}</slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="logOut()">{{ $t("confirm") }}</button>
                <button class="modal-default-button close" @click="(show2 = false), $emit('close')">{{ $t("cancel")
                }}</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </main>

</template>

<script>

import Form from "vform";
import CodeInput from "vue-verification-code-input";

import Vodal from "vodal";

import "vodal/common.css";
import "vodal/slide-down.css";
import "vodal/flip.css";
import "vodal/slide-left.css";
import { HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner } from "epic-spinners";

export default {
  components: {
    Vodal,
    CodeInput,
    HalfCircleSpinner,
    HollowDotsSpinner,
    CirclesToRhombusesSpinner

  },
  data: function () {
    return {
      //DBitems: null,
      forgetVodal: false,
      codeVodal: false,
      newPassVodal: false,
      DBitems: null,
      loading_order:true,
      errorMessageVodal: "",
      passemail: "",
      Newpassword: null,
      checkcomplete: false,
      finalcode: null,
      phone: null,
      show2: false,
      address: [],
      errorMessage: "",
      form: new Form({
        email: null,
        name: null,
        phone: null,
      }),
      show: false,
      show2: false,
      orders: [],
      count: 6,
      page: 1,
      pageSize: 6,
      loding_orders: true,
      loading_address: true
    };
  },

  created() {
    this.$store.state.showHeader = true;
    this.$store.state.showFooter = true;
    if (this.$route.params.lang && this.$route.params.lang != this.$i18n.locale) {
      this.$i18n.locale = this.$route.params.lang; this.$store.state.UnitPrice = this.$store.state.unitAR
      if (this.$i18n.locale == 'en') {
        document.documentElement.setAttribute("dir", "ltr");
        let h = document.querySelector('body');
      }
    }

    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/profile",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName)
          }
        }
      )
      .then(response => {
        this.form.email = response.data.data.email;
        this.form.name = response.data.data.name;
        this.phone = response.data.data.phone.substr(4);
        console.log('phone ' + this.phone);
        this.$localStorage.set(
          this.$store.user_phone,
          data.data.phone);
        console.log('******* ', response.data.data)
      })
      .catch(error => {

      });

    // 

    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/addresses",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
          }
        }
      )
      .then(response => {
        this.address = response.data.data.addresses.addresses;
        this.loading_address = false
        console.log('**** addressess', this.address);
      })
      .then((this.loading = false))
      .catch(error => {
        if (error.response.status == "401") {
          this.$localStorage.remove(this.$store.storeName);
          window.location.href = "/";

        }
      });


    this.axios
      .get(
        this.$store.state.base_api_url +
        this.$store.storeName +
        "/orders",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
          }
        }
      )
      .then(response => {
        this.orders = response.data.data.orders;
       this.count = response.data.meta.total;
        //this.pageSize = response.data.meta.per_page;

      })
      .then(() => (this.loading_order = false))
      .catch(error => {
        if (error.response.status == "401") {
          this.$localStorage.remove(this.$store.storeName);
          window.location.href = "/";

        }
      });
    //   

    if (this.$i18n.locale == 'ar') {
      document.title = this.$store.state.title_ar;
      document.getElementById("description_meta").content = this.$store.state.description_ar;
      document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
    }
    else {
      document.title = this.$store.state.title_en;
      document.getElementById("description_meta").content = this.$store.state.description_en;
      document.getElementById("keywords_meta").content = this.$store.state.keyword_en;
    }
  },
  methods: {

    async submitInfo() {
      this.form.phone = this.$store.state.country_code + this.phone;

      const response = await this.axios
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/profile/update",
          {
            email: this.form.email,
            name: this.form.name,
            phone: this.form.phone
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName)
            }
          }
        )
        .then(response => {
          if (response.data.code == "1") {
            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          } else if (response.data.code == "-1") {
            this.errorMessage = response.data.message;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
          if (response.data.error) {
            this.errorMessage = response.data.error;
            setTimeout(() => {
              this.errorMessage = "";
            }, 3000);
          }
        })
        .catch(error => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href = "/";
          }
        });
    },

    logOut() {
      this.loading = true;
      this.axios.get(
        this.$store.state.base_api_url + this.$store.storeName + "/logout",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName)
          }
        }
      );
      //console.group("hiiiiii")
      console.log(
        "logout:" +
        //this.$localStorage.id() +
        this.$localStorage.get(this.$store.storeName)
      );
      //this.$localStorage.remove("userToken");
      this.show2 = false;
      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        console.log('hhhhhhhhhhhhhhh111');
        if (AllCookies[i].split("/")[0] == this.$store.state.storeName) {
          this.$cookies.remove(console.log(AllCookies[i]));

        }
        this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))

      }
      console.log(AllCookies);
      /*if (this.$cookies.isKey(this.$store.storeName + product.product_id + product.final_option + product.option_check)) {
      this.$cookies.remove(this.$store.storeName + product.product_id + product.final_option + product.option_check)
      }*/
      this.$localStorage.remove(this.$store.storeName);
      window.location.reload();
      this.loading = false;
    },

    retrieveTutorials() {
      const params = this.page;

      this.loading_order = true;
      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/orders?page=" +
          params,
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
            }
          }
        )
        .then(response => {
          this.orders = response.data.data.orders;
          //this.count = response.data.meta.total;
          this.pageSize = response.data.meta.per_page;

        })
        .then(() => (this.loading_order = false))
        .catch(error => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href = "/";

          }
        });
      /*.catch((e) => {
          console.log(params);
          console.log(e);
        });*/
    },
    handlePageChange(value) {
      // alert('ccccc')
      this.page = value;
      this.retrieveTutorials();
    },
  },
  watch: {
    langchange() {
      if (this.$route.params.lang && this.$route.params.lang != this.$i18n.locale) {
        this.$i18n.locale = this.$route.params.lang; this.$store.state.UnitPrice = this.$store.state.unitAR
        if (this.$i18n.locale == 'en') {
          document.documentElement.setAttribute("dir", "ltr");
          let h = document.querySelector('body');
        }
      }

      this.axios
        .get(
          this.$store.state.base_api_url + this.$store.storeName + "/profile",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName)
            }
          }
        )
        .then(response => {
          this.form.email = response.data.data.email;
          this.form.name = response.data.data.name;
          this.phone = response.data.data.phone.substr(4);
          console.log('phone ' + this.phone);
          this.$localStorage.set(
            this.$store.user_phone,
            data.data.phone);
          console.log('******* ', response.data.data)
        })
        .catch(error => {

        });

      // 

      this.axios
        .get(
          this.$store.state.base_api_url + this.$store.storeName + "/addresses",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
            }
          }
        )
        .then(response => {
          this.address = response.data.data.addresses.addresses;
          this.loading_address = false
          console.log('**** addressess', this.address);
        })
        .then((this.loading = false))
        .catch(error => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href = "/";

          }
        });


      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/orders",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
            }
          }
        )
        .then(response => {
          this.orders = response.data.data.orders;
          this.count = response.data.meta.total;
          this.pageSize = response.data.meta.per_page;

        })
        .then(() => (this.loading_order = false))
        .catch(error => {
          if (error.response.status == "401") {
            this.$localStorage.remove(this.$store.storeName);
            window.location.href = "/";

          }
        });
      //   

      if (this.$i18n.locale == 'ar') {
        document.title = this.$store.state.title_ar;
        document.getElementById("description_meta").content = this.$store.state.description_ar;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
      }
      else {
        document.title = this.$store.state.title_en;
        document.getElementById("description_meta").content = this.$store.state.description_en;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_en;
      }
    }
  }
};
</script>
